export default [
  {
    path: '/merchant',
    name: 'merchant',
    component: () => import('@/views/menu/merchant/merchant.vue'),
    meta: {
      pageTitle: 'مدیریت بازرگانان',
      action: 'show',
      resource: 'MerchantManager',
    },
  },
]
